{
  // Handle setting initial slide when modal opens from grid image click
  document.addEventListener('click', (e) => {
    const toggler = e.target.closest('button[is="ada-modal-toggler"][data-slide-index]')
    if (!toggler) return

    const slideIndex = parseInt(toggler.getAttribute('data-slide-index'))
    const modalId = toggler.getAttribute('aria-controls')
    const modal = document.querySelector(`ada-modal#${modalId}`)
    
    if (modal) {
      // Listen for the modal open event
      const handleOpen = () => {
        const slider = modal.querySelector('ada-slider')
        if (slider && slider.$slick) {
          // Force slick to recalculate dimensions after modal is visible
          jQuery(slider).slick('setPosition')
          // Then go to the correct slide
          jQuery(slider).slick('slickGoTo', slideIndex)
        }
        modal.removeEventListener('open', handleOpen)
      }
      
      modal.addEventListener('open', handleOpen)
    }
  })

  // Also handle when modals open without data-slide-index (general case)
  document.addEventListener('click', (e) => {
    const toggler = e.target.closest('button[is="ada-modal-toggler"]')
    if (!toggler || toggler.hasAttribute('data-slide-index')) return

    const modalId = toggler.getAttribute('aria-controls')
    const modal = document.querySelector(`ada-modal#${modalId}`)
    
    if (modal) {
      const handleOpen = () => {
        const slider = modal.querySelector('ada-slider')
        if (slider && slider.$slick) {
          // Force slick to recalculate dimensions after modal is visible
          jQuery(slider).slick('setPosition')
        }
        modal.removeEventListener('open', handleOpen)
      }
      
      modal.addEventListener('open', handleOpen)
    }
  })
}
